import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';

import useLinkProps from '../../../hooks/use-link-props';
import BPImage from '../../ui/v2/image';
import FeaturedLink from '../../ui/links/featured';

const NoRiskInfo = () => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  const returnPolicy = (() => {
    const legal = t('footer:legal', undefined, {
      returnObjects: true,
    }) as unknown as Array<{ label: string; id: string; hash?: string }>;
    const links = legal.links;

    if (typeof links === 'object') {
      return links[links.length - 1];
    } else {
      null;
    }
  })();

  return (
    <div
      className={cx('grid grid-cols-[16px_1fr] gap-4 items-start', 'text-sm')}
    >
      <div className="mt-1">
        <BPImage
          src={`${process.env.PUBLIC_PREFIX}/svg/icons/no-risk.svg`}
          width={16}
          height={16}
          className={cx('h-4 w-4')}
          alt="No risk icon"
        />
      </div>
      <div>
        <b className="text-base">{t('product:no-risk.title')}</b>
        <p>{t('product:no-risk.description')}</p>
        {returnPolicy && (
          <Link
            {...getLink(returnPolicy.id, undefined, returnPolicy.hash)}
            shallow
            passHref
            prefetch={false}
            legacyBehavior
          >
            <FeaturedLink as="a" target="_blank" variant="blackBold">
              {t('product:no-risk.link')}
            </FeaturedLink>
          </Link>
        )}
      </div>
    </div>
  );
};

export default NoRiskInfo;
